import React, { useState } from 'react';
import * as Accordion from '@radix-ui/react-accordion';
import * as Dialog from '@radix-ui/react-dialog';
import subscribeToNewsletter from '../../API/NewsLetter';
import unsubscribeFromNewsletter from '../../API/unsubscribeAPI';
import './Newsletter.css';

const fakeNewsletters = [
  { id: 1, date: '2023-09-01', title: 'September Update', url: 'https://cdnmychurchofchrist.nyc3.cdn.digitaloceanspaces.com/newsletter/New%20Text%20Document.html' },
  { id: 2, date: '2023-08-01', title: 'August Update', url: 'https://example.com/newsletter2' },
  // Add more newsletters as needed...
];

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isSubscribing, setIsSubscribing] = useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  // Helper function to validate email format
  const isValidEmail = (email) => {
    // Simple regex for validating email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  // Handle Subscribe or Unsubscribe submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate if email is empty
    if (!email) {
      setMessage('Please enter your email address.');
      setDialogOpen(true);
      return;
    }

    // Validate if email format is incorrect
    if (!isValidEmail(email)) {
      setMessage('Please enter a valid email address.');
      setDialogOpen(true);
      return;
    }

    setMessage('');
    setIsLoading(true);
    
    try {
      const result = isSubscribing
        ? await subscribeToNewsletter(email)
        : await unsubscribeFromNewsletter(email);
        
      setMessage(result.message);
      
      if (result.success) {
        setEmail('');
      } else {
        setDialogOpen(true);
      }
    } catch (error) {
      setMessage('An error occurred. Please try again later.');
      setDialogOpen(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
<div className="bg-gray-100 py-20 px-8 md:px-10">
  <div className="max-w-7xl mx-auto px-4 md:px-10">
    {/* Flex container for Accordion and Subscription Form */}
    <div className="flex flex-col md:flex-row md:space-x-4">
      {/* Accordion Section */}
      <div className="w-full md:w-2/3 flex-shrink-0"> {/* Prevent flexbox stretching */}
        <Accordion.Root type="multiple" className="space-y-4">
          {fakeNewsletters.map((newsletter) => (
            <Accordion.Item
              key={newsletter.id}
              value={newsletter.id.toString()}
              className="bg-white shadow-md rounded-lg"
            >
              <Accordion.Header>
                {/* Accordion Trigger */}
                <Accordion.Trigger className="w-full text-left text-lg font-semibold bg-gray-200 hover:bg-gray-300 transition-colors px-4 py-2 md:px-6">
                  {newsletter.date} - {newsletter.title}
                </Accordion.Trigger>
              </Accordion.Header>
              {/* Accordion Content */}
              <Accordion.Content className="bg-gray-50 px-4 py-2 md:px-6">
                <div className="iframe-wrapper px-0">
                  <iframe
                    src={newsletter.url}
                    title={newsletter.title}
                    className="iframe-content w-full border-none"
                    style={{ height: '600px' }}
                  />
                </div>
              </Accordion.Content>
            </Accordion.Item>
          ))}
        </Accordion.Root>
      </div>

      {/* Subscription Form Section */}
      <div className="w-full md:w-1/3 mt-8 md:mt-0 bg-white shadow-lg rounded-lg p-8 px-5">
        <h2 className="text-3xl font-bold mb-6">
          {isSubscribing ? 'Subscribe' : 'Unsubscribe'} to Newsletter
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email"
            className="w-full p-3 border border-gray-300 rounded-md focus:ring focus:ring-blue-500"
            required
          />
          <button
            type="submit"
            className="w-full bg-blue-600 text-white py-3 rounded-md hover:bg-blue-700 transition-colors"
            disabled={isLoading}
          >
            {isLoading
              ? isSubscribing
                ? 'Subscribing...'
                : 'Unsubscribing...'
              : isSubscribing
              ? 'Subscribe'
              : 'Unsubscribe'}
          </button>
        </form>

        {/* Toggle between Subscribe and Unsubscribe */}
        <button
          onClick={() => setIsSubscribing(!isSubscribing)}
          className="mt-4 text-blue-600 underline hover:text-blue-800"
        >
          {isSubscribing ? 'Want to unsubscribe?' : 'Want to subscribe instead?'}
        </button>

        {/* Show message if API call returns a message */}
        {message && (
          <p
            className={`mt-4 text-lg ${
              message.includes('successful') ? 'text-green-500' : 'text-red-500'
            }`}
          >
            {message}
          </p>
        )}
      </div>
    </div>
  </div>

  {/* Radix UI Dialog for Error or Validation Messages */}
  <Dialog.Root open={dialogOpen} onOpenChange={setDialogOpen}>
    <Dialog.Overlay className="fixed inset-0 bg-black opacity-50" />
    <Dialog.Content className="fixed bg-white p-6 rounded-lg shadow-lg top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
      <Dialog.Title className="text-xl font-semibold">Notification</Dialog.Title>
      <Dialog.Description className="mt-2">{message}</Dialog.Description>
      <button
        onClick={() => setDialogOpen(false)}
        className="mt-4 bg-blue-600 text-white py-2 px-4 rounded-md hover:bg-blue-700"
      >
        OK
      </button>
    </Dialog.Content>
  </Dialog.Root>
</div>

  );
};

export default Newsletter;
